export interface SelectOptionType {
  label: string;
  value: string;
}
export interface IPaginationParamsProps {
  page: number;
  pageSize: number;
}

export enum AvailableCurrencies {
  BRL = "BRL",
  USD = "USD",
}

export enum AvailableLanguages {
  "pt-BR" = "pt-BR",
  "en-US" = "en-US",
}

export const LanguageOptions = [
  {
    value: AvailableLanguages["pt-BR"],
    label: "Português",
  },
  {
    value: AvailableLanguages["en-US"],
    label: "Inglês",
  },
];

export const CurrencyOptions = [
  {
    value: AvailableCurrencies.BRL,
    label: "Real (R$)",
  },
  // {
  //   value: AvailableCurrencies.USD,
  //   label: "Dólar ($)",
  // },
];
